import React, { Component } from "react";
import { Chart } from "primereact/chart";
import { Dropdown } from "primereact/dropdown";
import DashboardService from "../services/DashboardService";
import WareHouseMaterService from "../services/WareHouseMaterService";
import ApiService from "../services/apiService";
import dashboradimg from "./../assets/images/dashboard.png";
import Loaders from "./../template/Loaders";
import { Chart as GoogleChart } from "react-google-charts";
import "./Dashboard.css";

import CanvasJSReact from "@canvasjs/react-charts";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Dashdata: false,
      TotalMapping: 0,
      TotalDeMapping: 0,
      TotalDamage: 0,
      TotalGenerate: 0,
      TotalPacked: 0,
      TotalDispatched: 0,
      TotalCartonsPacked: 0,
      TotalCartonsDispatched: 0,
      TotalReceived: 0,
      TotalCartonsReceived: 0,
      updateLoader: false,
      TotalGenerated: 0,
      Months: [],
      selval: "Loading",
      DeMappings: [],
      Mappings: [],
      dropDownValue: "",
      NumberIssue: [],
      Damage: [],
      largestNumber: 0,
      factoryDDL: [],
      isAdmin: false,
      selectedFilter: "all",
      startDate: "",
      endDate: "",
      isPreprintedValue: "Static Qr Mapping",
      isPreprinted: false,
      options: {
        pieSliceText: "none",
        plugins: {
          labels: {
            render: () => { },
          },
        },
      },
    };
    this.WareHouseMaterService = new WareHouseMaterService();
    this.DashboardService = new DashboardService();
    this.ApiService = new ApiService();
    this.setPreprintedValue = this.setPreprintedValue.bind(this);
  }
  //trigger api function on page call

  componentDidMount() {
    debugger;
    const val = sessionStorage.getItem("userType");
    this.setState({
      UserType: val,
    });
    if (val == 2 || val == 1) {
      this.setState({
        Dashdata: true,
      });
    } else {
      setTimeout(() => {
        if (
          sessionStorage.getItem("userType") == 0 ||
          sessionStorage.getItem("userType") == 7
        ) {
          this.setState({
            isAdmin: true,
          });
        } else {
          this.GetDashboardData("", false);
        }
        this.GetAllFactory(0);
      }, 200);

      setTimeout(() => {
        if (this.state.isAdmin) {
          this.GetDashboardData(this.state.factoryDDL[0]?.ID, false);
          this.setState({
            selval: this.state.factoryDDL[0]?.FirmName,
          });
        }
      }, 2000);
    }
  }

  onFilterSelect = (filter) => {
    // Reset date inputs
    this.setState({
      selectedFilter: filter,
      startDate: "",
      endDate: ""
    }, () => {
      this.GetDashboardDataForFilter(filter);
    });
  };

  onDateChange = (e, type) => {
    this.setState({
      [type === "start" ? "startDate" : "endDate"]: e.target.value,
      selectedFilter: "" // Deselect filter since custom dates are used
    });
  };

  onDateRangeApply = () => {
    if (!this.state.startDate || !this.state.endDate) return;
    this.GetDashboardDataForFilter("range", this.state.startDate, this.state.endDate);
  };

  GetDashboardDataForFilter = (filter, startDate, endDate) => {
    let filterParams = {};
    switch (filter) {
      case "today":
        filterParams = { filterType: "today" };
        break;
      case "week":
        filterParams = { filterType: "week" };
        break;
      case "month":
        filterParams = { filterType: "month" };
        break;
      case "range":
        filterParams = { startDate, endDate };
        break;
      default:
        filterParams = {};
    }
    // You may need to adapt param names for your API
    this.GetDashboardData(this.state.dropDownValue, this.state.isPreprinted, filterParams);
  };
  handleChange(e) {
    const Id = e.target.value;
    this.setState({
      dropDownValue: e.target.value,
    });
    let IsFactory = this.state.factoryDDL.filter((x) => x.ID == Id)[0]
      .IsFactory;
    if (IsFactory) {
      this.setState({ UserType: 4 });
    } else {
      this.setState({ UserType: 5 });
    }
    this.GetDashboardData(Id, false);
  }
  // Get Dashboard Data
  GetDashboardData(Id, isPreprinted, filterParams = {}) {
    const formdata = { Id: Id, isPreprinted: isPreprinted, ...filterParams };
    this.DashboardService.GetDashboardData(formdata).then((data) => {
      const resdata = data.data;
      //if ResponseCode is 200
      if (resdata.ResponseCode === "200") {
        this.setState({ updateLoader: true });
        const res = resdata.ResponseData;
        const DashboardCount = res.DashboardCount;
        const MonthName = res.MonthName;
        const DeMappingList = res.DeMappingList;
        const MappingList = res.MappingList;
        const NumberList = res.NumberList;
        const DamageNumberList = res.DamageList;
        //DashboardCount not null
        if (DashboardCount != null) {
          this.setState({
            TotalMapping: DashboardCount.TotalMapping,
            TotalDeMapping: DashboardCount.TotalDeMapping,
            TotalDamage: DashboardCount.TotalDamage,
            TotalGenerated: DashboardCount.TotalGenerate,
            TotalPacked: DashboardCount.TotalPacked,
            TotalDispatched: DashboardCount.TotalDispatched,
            TotalCartonsPacked: DashboardCount.TotalCartonsPacked,
            TotalCartonsDispatched: DashboardCount.TotalCartonsDispatched,
            TotalReceived: DashboardCount.TotalReceived,
            TotalCartonsReceived: DashboardCount.TotalCartonsReceived,
          });

          var largest = 0;
          const array = [
            DashboardCount.TotalMapping,
            DashboardCount.TotalDeMapping,
            DashboardCount.TotalDamage,
            DashboardCount.TotalIssue,
          ];
          for (let i = 0; i <= largest; i++) {
            if (array[i] > largest) {
              var largest = array[i];
            }
          }

          this.setState({
            largestNumber: largest,
          });
        }
        //MonthName not null
        if (MonthName != null && MonthName.length > 0) {
          this.setState({
            Months: MonthName,
          });
        }
        //DeMappingList not null
        if (DeMappingList != null && DeMappingList.length > 0) {
          this.setState({
            DeMappings: DeMappingList,
          });
        }
        //MappingList not null
        if (MappingList != null && MappingList.length > 0) {
          this.setState({
            Mappings: MappingList,
          });
        }
        //NumberList not null
        if (NumberList != null && NumberList.length > 0) {
          this.setState({
            NumberIssue: NumberList,
          });
        }
        //DamageNumberList not null
        if (DamageNumberList != null && DamageNumberList.length > 0) {
          this.setState({
            Damage: DamageNumberList,
          });
        }
      }
    });
  }
  GetAllFactory(compId) {
    this.WareHouseMaterService.GetWareHouseDDL(compId).then((data) => {
      const resdata = data.data;
      //if resdata is not null state of wareHouseDDL will be set with ResponseData
      if (
        resdata !== null &&
        resdata.ResponseData !== null &&
        resdata.ResponseData.length > 0
      ) {
        var factory = resdata.ResponseData.filter((x) => x.IsFactory == true);
        const warehouse = resdata.ResponseData.filter(
          (x) => x.IsFactory == false
        );
        const mergedArr = [...factory, ...warehouse];
        this.setState({
          factoryDDL: mergedArr,
        });
      }
    });
  }
  /// to set isPreprinted
  setPreprintedValue(e) {
    this.setState(
      {
        isPreprintedValue: e.value,
        isPreprinted: e.value == "Static Qr Mapping" ? false : true,
      },
      () => {
        this.GetDashboardData("", this.state.isPreprinted);
      }
    );
  }
  // return HTML
  render() {
    const data = {
      labels: this.state.Months,
      datasets: [
        {
          label: "Number Issued",
          data: this.state.NumberIssue,
          fill: false,
          borderColor: "#4bc0c0",
        },

        {
          label: "Damage",
          data: this.state.Damage,
          fill: false,
          borderColor: "#c74e1a",
        },

        {
          label: "Product Mapping",
          data: this.state.Mappings,
          fill: false,
          borderColor: "#97A5A5",
        },
        // {
        //   label: 'Product De-Mapping',
        //   data: this.state.DeMappings,
        //   fill: false,
        //   borderColor: '#150e0b'
        // },
      ],
    };

    const professionalOptions = {
      colors: ["#4E79A7", "#F28E2B"],
      pieHole: 0.4,
      animation: {
        startup: true,
        duration: 1000,
        easing: "out",
      },
      legend: {
        textStyle: { color: "#333", fontSize: 14 },
        position: "right",
      },
      backgroundColor: "transparent",
      chartArea: {
        width: "90%",
        height: "80%",
      },
    };

    const optionsMappedPacked = {
      colors: ["#449132", "#455A64"],
      animation: {
        startup: true,
        duration: 1000,
        easing: "out",
      },

      legend: { textStyle: { color: "#333", fontSize: 14 } },
      chartArea: { width: "75%", height: "55%" },
      backgroundColor: "transparent",
    };

    const optionsPackedDispatched = {
      pieHole: "0.4",
      colors: ["#5C6BC0", "#F4A261"],
      animation: {
        startup: true,
        duration: 1000,
        easing: "out",
      },

      legend: { textStyle: { color: "#333", fontSize: 14 } },
      chartArea: { width: "75%", height: "55%" },
      backgroundColor: "transparent",
    };

    const optionsCartons = {
      colors: ["#A1887F", "#4DD0E1"],
      animation: {
        startup: true,
        duration: 1000,
        easing: "out",
      },

      legend: { textStyle: { color: "#333", fontSize: 14 } },
      chartArea: { width: "90%", height: "80%" },
      backgroundColor: "transparent",
    };
    // new dashboard
    const mvspoptions = {
      animationEnabled: true,
      height: 210,
      legend: {
        verticalAlign: "center",
        horizontalAlign: "right",
        fontColor: "#4A90E2",
        fontSize: 14,
      },
      data: [
        {
          type: "pie",
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong>{y}</strong>",
          indexLabel: "{y}",
          indexLabelPlacement: "inside",
          indexLabelFontColor: "#fff",
          dataPoints: [
            { y: this.state.TotalMapping, label: "Mapped", color: "#9bbb58" },
            { y: this.state.TotalPacked, label: "Packed", color: "#c0504e" },
          ],
        },
      ],
    };

    const dataPoints = [
      { label: "Packed", y: this.state.TotalPacked, color: "#9bbb58" },
      { label: "Dispatched", y: this.state.TotalDispatched, color: "#d9b46e" },
    ];

    const total = dataPoints[0].y;
    dataPoints.forEach((point, index) => {
      point.percentage =
        index === 0 ? 100 : ((point.y / total) * 100).toFixed(2);
    });

    const options = {
      height: 200,
      animationEnabled: true,
      legend: {
        horizontalAlign: "right",
        verticalAlign: "center",
        reversed: true,
        fontSize: 14,
      },
      data: [
        {
          type: "pyramid",
          showInLegend: true,
          legendText: "{label}",
          indexLabel: "{label} - {y}",
          toolTipContent: "<b>{label}</b>: {y}</b>",
          dataPoints: dataPoints,
        },
      ],
    };

    const Cpvscdoptions = {
      animationEnabled: true,
      height: 205,
      legend: {
        verticalAlign: "center", // Align legend vertically
        horizontalAlign: "right", // Position legend to the right
        fontColor: "#4A90E2", // Change this to any color you like
        fontSize: 14,
      },
      data: [
        {
          type: "doughnut",
          innerRadius: "60%", // Makes it a donut chart
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong>{y}</strong>",
          indexLabel: "{y}",
          indexLabelPlacement: "inside",
          indexLabelFontColor: "#fff",
          dataPoints: [
            {
              y: this.state.TotalCartonsPacked,
              label: "Carton Packed",
              color: "#75b366",
            },
            {
              y: this.state.TotalCartonsDispatched,
              label: "Carton Dispatched",
              color: "#4c9ca0",
            },
          ],
        },
      ],
    };

    const n_d_pm_options = {
      animationEnabled: true,
      height: 240,
      axisX: {
        valueFormatString: "MMM",
        labelFontSize: 12,
        gridColor: "#e0e0e0",
      },
      axisY: {
        labelFontSize: 12,
        labelFormatter: function (e) {
          return e.value.toLocaleString();
        },
        gridColor: "#e0e0e0",
      },
      toolTip: {
        shared: true,
        content: "{name}: {y}",
      },
      legend: {
        fontSize: 13,
      },
      data: [
        {
          type: "splineArea",
          showInLegend: true,
          name: "Number Issued",
          markerSize: 0,
          color: "rgba(54,158,173,.9)",
          dataPoints: this.state.NumberIssue.map((y, i) => ({
            x: new Date(2020, i),
            y,
          })),
        },
        {
          type: "splineArea",
          showInLegend: true,
          name: "Product Mapping",
          markerSize: 0,
          color: "rgba(134,180,2,.9)",
          dataPoints: this.state.Mappings.map((y, i) => ({
            x: new Date(2020, i),
            y,
          })),
        },
        {
          type: "splineArea",
          showInLegend: true,
          name: "Damage",
          markerSize: 0,
          color: "rgba(194,70,66,.9)",
          dataPoints: this.state.Damage.map((y, i) => ({
            x: new Date(2020, i),
            y,
          })),
        },
      ],
    };

    // warehouse
    const rvsdoptions = {
      animationEnabled: true,
      height: 280,
      legend: {
        verticalAlign: "center",
        horizontalAlign: "right",
        fontColor: "#4A90E2",
        fontSize: 14,
      },
      data: [
        {
          type: "pie",
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong>{y}</strong>",
          indexLabel: "{y}",
          indexLabelPlacement: "inside",
          indexLabelFontColor: "#fff",
          dataPoints: [
            {
              y: this.state.TotalReceived,
              label: "Received",
              color: "#9bbb58",
            },
            {
              y: this.state.TotalDispatched,
              label: "Dispatched",
              color: "#c0504e",
            },
          ],
        },
      ],
    };

    const Crvscdoptions = {
      animationEnabled: true,
      height: 280,
      legend: {
        verticalAlign: "center", // Align legend vertically
        horizontalAlign: "right", // Position legend to the right
        fontColor: "#4A90E2", // Change this to any color you like
        fontSize: 14,
      },
      data: [
        {
          type: "doughnut",
          innerRadius: "60%", // Makes it a donut chart
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong>{y}</strong>",
          indexLabel: "{y}",
          indexLabelPlacement: "inside",
          indexLabelFontColor: "#fff",
          dataPoints: [
            {
              y: this.state.TotalCartonsReceived,
              label: "Cartons Received",
              color: "#75b366",
            },
            {
              y: this.state.TotalCartonsDispatched,
              label: "Carton Dispatched",
              color: "#4c9ca0",
            },
          ],
        },
      ],
    };
    // end

    return (
      <>
        {/* <SelectButton value={this.state.isPreprintedValue} className="custom-tab" options={options} onChange={this.setPreprintedValue} /> */}
        {this.state.isAdmin ? (
          <div>
            <div className="row">
              <div
                style={{ margin: "0px 0px 30px 5px" }}
                className="col-md-8 mb-2"
              >
                <span className="pl-4 pt-2">Select Entity :</span>
                {/* <Dropdown
                  virtualScroll="true"
                  appendTo={document.getElementById("body")}
                  style={{
                    margin: "0px 300px 0px 300px",
                    position: "fixed",
                    left: "unset !important",
                    right: 0,
                  }}
                  optionLabel="FirmName"
                  value={this.state.dropDownValue}
                  onChange={(e) => {
                    this.handleChange(e);
                  }}
                  className="form-control"
                  placeholder={this.state.selval}
                  name="WareHouseId"
                  options={this.state.factoryDDL}
                /> */}

                <select
                  className="form-control"
                  value={this.state.dropDownValue}
                  onChange={(e) => {
                    this.handleChange(e);
                  }}
                  placeholder={this.state.selval}
                  style={{
                    width: "300px",
                    display: "inline-block",
                    marginLeft: "10px",
                  }}
                >
                  {this.state.factoryDDL.map((e, key) => {
                    return (
                      <option key={e.ID} value={e.ID}>
                        {e.FirmName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* At the top of your render(), before the dashboard content: */}
        <div className="dashboard-filters row align-items-center mb-3" style={{ padding: "10px 25px 5px" }}>
         
         
        </div>


        {this.state.Dashdata ? (
          <div>
            <img
              style={{ borderRadius: "10px", width: "100%", height: "10%" }}
              src={dashboradimg}
              alt="Jasmine BioLabs Dashboard"
            />
          </div>
        ) : (
          <section className=" warehouse-dash container-fluid">
            <div className="container-fluid mt-1">
              <Loaders loader={this.state.updateLoader} />
              <div
                className="row no-gutterss "
                hidden={
                  this.state.UserType == 1 || this.state.UserType == 5
                    ? true
                    : false
                }
              >
                <div className="container-fluid">
                  <div className="row g-3">
                    
                    {/* First Column */}
                    <div className="col-md-3">
                      <div>
                            <button className={`btn btn-outline-primary mx-2 ${this.state.selectedFilter === 'today' ? 'active' : ''}`}
                              onClick={() => this.onFilterSelect('today')} style={{ minWidth: '70px' }}>Today</button>
                            <button className={`btn btn-outline-primary mx-1 ${this.state.selectedFilter === 'week' ? 'active' : ''}`}
                              onClick={() => this.onFilterSelect('week')} style={{ minWidth: '70px' }} >Week</button>
                            <button className={`btn btn-outline-primary mx-1 ${this.state.selectedFilter === 'month' ? 'active' : ''}`}
                              onClick={() => this.onFilterSelect('month')}  style={{ minWidth: '70px' }} >Month</button>
                            <button className={`btn btn-outline-primary mx-1 ${this.state.selectedFilter === 'all' ? 'active' : ''}`}
                              onClick={() => this.onFilterSelect('all')} style={{ minWidth: '50px' }} >All</button>
                     </div>
                      <div style={{marginTop:10}}>
                            <input
                              type="date"
                              className="form-control d-inline-block"
                              value={this.state.startDate}
                              onChange={e => this.onDateChange(e, "start")}
                              style={{ width: 100, height: 30 }}
                            />
                            <span style={{ padding: "0 8px" }}>To</span>
                            <input
                              type="date"
                              className="form-control d-inline-block"
                              value={this.state.endDate}
                              onChange={e => this.onDateChange(e, "end")}
                              style={{ width: 100, height: 30}}
                            />
                             <button className="btn btn-success mx-1"
                              onClick={this.onDateRangeApply}>Apply</button>
                      </div>
                      <div className="container-fluid">
                        
                        {/* <div className="row ">
                          <div className="col-md-12 n_issue_card">
                            <div className="row">
                              <div className="col-md-2 ">
                                <span className="n_issue_icn">
                                  <i className="fa fa-file-alt" />
                                </span>
                              </div>
                              <div className="col-md-10  text-center">
                                <p className="n_issue_count">
                                  {" "}
                                  {this.state.TotalGenerated}
                                </p>
                                <p className="n_issue_text">
                                  Total Number Issued
                                </p>
                              </div>
                            </div>
                          </div>
                        </div> */}

                         
                        {/* second row */}
                        <div className="row mt-3">
                          <div className="col-md-12 n_issue_card">
                            <div className="row" >
                              <div className="col-md-2">
                                <span className="n_issue_icn n_mapped_icn">
                                  <i className="fa fa-sitemap" />
                                </span>
                              </div>
                              <div className="col-md-10  text-center">
                                <p className="n_issue_count">
                                  {" "}
                                  {this.state.TotalMapping}
                                </p>
                                <p className="n_issue_text">
                                  Total Numbers Mapped
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* third row */}
                        <div className="row mt-3">
                          <div className="col-md-12 n_issue_card">
                            <div className="row">
                              <div className="col-md-2">
                                <span className="n_issue_icn damage_icn">
                                  <i className="fa fa-times-circle" />
                                </span>
                              </div>
                              <div className="col-md-10  text-center">
                                <p className="n_issue_count">
                                  {" "}
                                  {this.state.TotalDamage}
                                </p>
                                <p className="n_issue_text">
                                  Total Numbers Damaged
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Second Column */}
                    <div className="col-md-4">
                      <div className="n_issue_card mapped_vs_packed_card p-3">
                        <div className="chart_head_col mb-2">
                          <span className="chart_head">Mapped V/s Packed</span>
                        </div>

                        <div
                          className="f_chart_body"
                          style={{ height: "220px" }}
                        >
                          {this.state.isAdmin ? (
                            <div className="admin-info"></div>
                          ) : (
                            ""
                          )}
                          <CanvasJSChart options={mvspoptions} />
                        </div>
                      </div>
                    </div>

                    {/* Third Column */}
                    <div className="col-md-5">
                      <div className="n_issue_card  mapped_vs_packed_card p-3">
                        <div className="chart_head_col mb-2">
                          <span className="chart_head">
                            Packed V/s Dispatched
                          </span>
                        </div>

                        <div>
                          {this.state.isAdmin ? (
                            <div className="admin-info"></div>
                          ) : (
                            ""
                          )}
                          <CanvasJSChart options={options} />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* second row */}
                  <div className="row g-3 mt-3">
                    {/* Second Column */}
                    <div className="col-md-4">
                      <div className="n_issue_card mapped_vs_packed_card p-3">
                        <div className="chart_head_col mb-2">
                          <span className="chart_head">
                            Carton Packed V/s Carton Dispatched
                          </span>
                        </div>
                        <div
                          className="f_chart_body"
                          style={{ height: "212px" }}
                        >
                          {this.state.isAdmin ? (
                            <div className="admin-info"></div>
                          ) : (
                            ""
                          )}
                          <CanvasJSChart options={Cpvscdoptions} />
                        </div>
                      </div>
                    </div>

                    {/* Third Column */}
                    <div className="col-md-8">
                      <div className="n_issue_card  mapped_vs_packed_card p-3">
                        <Loaders loader={this.state.updateLoader} />
                        <div className="n_d_pm_chart mt-4">
                          <CanvasJSChart options={n_d_pm_options} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="row no-gutterss "
                hidden={this.state.UserType == 5 ? false : true}
              >
                <div className="col-md-6">
                  <div className="n_issue_card carton_received_vs_carton_dispatch_card p-3">
                    <div className="chart_head_col mb-2">
                      <span className="chart_head">Received vs Dispatched</span>
                    </div>

                    <div className="f_chart_body" style={{ height: "300px" }}>
                      {this.state.isAdmin ? (
                        <div className="admin-info"></div>
                      ) : (
                        ""
                      )}
                      <CanvasJSChart options={rvsdoptions} />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="n_issue_card carton_received_vs_carton_dispatch_card p-3">
                    <div className="chart_head_col mb-2">
                      <span className="chart_head">
                        Cartons Received vs Cartons Dispatched
                      </span>
                    </div>
                    <div className="f_chart_body" style={{ height: "300px" }}>
                      {this.state.isAdmin ? (
                        <div className="admin-info"></div>
                      ) : (
                        ""
                      )}
                      <CanvasJSChart options={Crvscdoptions} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row chart-sec">
                <div className="col-md-12">
                  {this.state.Dashdata ? (
                    <div
                      id="carousel"
                      className="carousel slide hero-slides"
                      data-ride="carousel"
                    >
                      <div className="carousel-inner" role="listbox">
                        <div className="carousel-item active boat">
                          <div className="container h-100  d-md-block">
                            <div className="row align-items-center h-100">
                              <div className="col-12 col-md-10 col-lg-10 col-xl-12">
                                <div className="caption animated fadeIn">
                                  <h2 className="animated fadeInLeft">
                                    <img src="img/slide-1.png" alt="logo" />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item sea">
                          <div className="container h-100 d-md-block">
                            <div className="row align-items-center h-100">
                              <div className="col-12 col-md-10 col-lg-10 col-xl-12">
                                <div className="caption animated fadeIn">
                                  <h2 className="animated fadeInLeft">
                                    <img src="img/slide-2.png" alt="logo" />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item river">
                          <div className="container h-100  d-md-block">
                            <div className="row align-items-center h-100">
                              <div className="col-12 col-md-10 col-lg-10 col-xl-12">
                                <div className="caption animated fadeIn">
                                  <h2 className="animated fadeInLeft">
                                    <img src="img/slide-3.png" alt="logo" />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        className="carousel-control-prev"
                        href="#carousel"
                        role="button"
                        data-slide="prev"
                      >
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        />
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="carousel-control-next"
                        href="#carousel"
                        role="button"
                        data-slide="next"
                      >
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        />
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
                  ) : (
                    <div className=""></div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}
      </>
    );
  }
}
